"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var DEFAULT_PROPS = {
  resourceType: 'ArticleListing_1_0_0',
  viewMoreLabel: 'View More',
  type: 'Image',
  pageSize: 3,
  articles: [{
    date: '2019-01-18T20:13:26.925Z',
    articleInformation: {
      id: '1',
      readTime: '4 Mins',
      mainHeading: 'Heritage series: Lancer Evolution X FQ-400',
      paragraph: 'Mitsubishi Motors Corporation (MMC) has announced that Alessandro Dambrosio is to join MMC as Executive Design Director of Advanced Design. He will lead teams at three design.',
      link: {
        url: '#',
        label: 'Read Article',
        priority: 'low',
        openNewTab: true
      },
      image: {
        image: 'https://cms.dev.mmcmason.co/content/dam/mitsubishi-motors-glue/heritage.jpg',
        altText: 'Heritage series'
      }
    }
  }, {
    date: '2019-01-18T20:13:26.925Z',
    articleInformation: {
      id: '2',
      readTime: '4 Mins',
      mainHeading: 'Desert warrior: The rocks',
      paragraph: 'Day three was mostly a travel day. Tom explained to our guide Paul that he wanted a variety of terrain to test.',
      link: {
        url: '#',
        label: 'Read Article',
        priority: 'low',
        openNewTab: true
      },
      image: {
        image: 'https://cms.dev.mmcmason.co/content/dam/mitsubishi-motors-glue/dessert.jpg',
        altText: 'Desert warrior'
      }
    }
  }, {
    date: '2019-01-19T20:13:26.925Z',
    articleInformation: {
      id: '3',
      readTime: '4 Mins',
      mainHeading: 'All-new Outlander PHEV TV ad',
      paragraph: 'Be on the lookout – Our new TV advert for the all-new Outlander PHEV airs today!',
      link: {
        url: '#',
        label: 'Read Article',
        priority: 'low',
        openNewTab: true
      },
      image: {
        image: 'https://cms.dev.mmcmason.co/content/dam/mitsubishi-motors-glue/outlander.jpg',
        altText: 'Outlander PHEV'
      }
    }
  }, {
    date: '2019-01-19T20:13:26.925Z',
    articleInformation: {
      id: '4',
      readTime: '4 Mins',
      mainHeading: 'Heritage series: Lancer Evolution X FQ-400',
      paragraph: 'Mitsubishi Motors Corporation (MMC) has announced that Alessandro Dambrosio is to join MMC as Executive Design Director of Advanced Design. He will lead teams at three design.',
      link: {
        url: '#',
        label: 'Read Article',
        priority: 'low',
        openNewTab: true
      },
      image: {
        image: 'https://cms.dev.mmcmason.co/content/dam/mitsubishi-motors-glue/heritage.jpg',
        altText: 'Heritage series'
      }
    }
  }, {
    date: '2019-01-20T20:13:26.925Z',
    articleInformation: {
      id: '5',
      readTime: '4 Mins',
      mainHeading: 'Desert warrior: The rocks',
      paragraph: 'Day three was mostly a travel day. Tom explained to our guide Paul that he wanted a variety of terrain to test.',
      link: {
        url: '#',
        label: 'Read Article',
        priority: 'low',
        openNewTab: true
      },
      image: {
        image: 'https://cms.dev.mmcmason.co/content/dam/mitsubishi-motors-glue/dessert.jpg',
        altText: 'Desert warrior'
      }
    }
  }, {
    date: '2019-01-20T20:13:26.925Z',
    articleInformation: {
      id: '6',
      readTime: '4 Mins',
      mainHeading: 'All-new Outlander PHEV TV ad',
      paragraph: 'Be on the lookout – Our new TV advert for the all-new Outlander PHEV airs today!',
      link: {
        url: '#',
        label: 'Read Article',
        priority: 'low',
        openNewTab: true
      },
      image: {
        image: 'https://cms.dev.mmcmason.co/content/dam/mitsubishi-motors-glue/outlander.jpg',
        altText: 'Outlander PHEV'
      }
    }
  }, {
    date: '2019-01-21T20:13:26.925Z',
    articleInformation: {
      id: '7',
      readTime: '4 Mins',
      mainHeading: 'Heritage series: Lancer Evolution X FQ-400',
      paragraph: 'Mitsubishi Motors Corporation (MMC) has announced that Alessandro Dambrosio is to join MMC as Executive Design Director of Advanced Design. He will lead teams at three design.',
      link: {
        url: '#',
        label: 'Read Article',
        priority: 'low',
        openNewTab: true
      },
      image: {
        image: 'https://cms.dev.mmcmason.co/content/dam/mitsubishi-motors-glue/heritage.jpg',
        altText: 'Heritage series'
      }
    }
  }, {
    date: '2019-01-21T20:13:26.925Z',
    articleInformation: {
      id: '8',
      readTime: '4 Mins',
      mainHeading: 'Desert warrior: The rocks',
      paragraph: 'Day three was mostly a travel day. Tom explained to our guide Paul that he wanted a variety of terrain to test.',
      link: {
        url: '#',
        label: 'Read Article',
        priority: 'low',
        openNewTab: true
      },
      image: {
        image: 'https://cms.dev.mmcmason.co/content/dam/mitsubishi-motors-glue/dessert.jpg',
        altText: 'Desert warrior'
      }
    }
  }, {
    date: '2019-01-22T20:13:26.925Z',
    articleInformation: {
      id: '9',
      readTime: '4 Mins',
      mainHeading: 'All-new Outlander PHEV TV ad',
      paragraph: 'Be on the lookout – Our new TV advert for the all-new Outlander PHEV airs today!',
      link: {
        url: '#',
        label: 'Read Article',
        priority: 'low',
        openNewTab: true
      },
      image: {
        image: 'https://cms.dev.mmcmason.co/content/dam/mitsubishi-motors-glue/outlander.jpg',
        altText: 'Outlander PHEV'
      }
    }
  }, {
    date: '2019-01-22T20:13:26.925Z',
    articleInformation: {
      id: '10',
      readTime: '4 Mins',
      mainHeading: 'Heritage series: Lancer Evolution X FQ-400',
      paragraph: 'Mitsubishi Motors Corporation (MMC) has announced that Alessandro Dambrosio is to join MMC as Executive Design Director of Advanced Design. He will lead teams at three design.',
      link: {
        url: '#',
        label: 'Read Article',
        priority: 'low',
        openNewTab: true
      },
      image: {
        image: 'https://cms.dev.mmcmason.co/content/dam/mitsubishi-motors-glue/heritage.jpg',
        altText: 'Heritage series'
      }
    }
  }]
};
var _default = DEFAULT_PROPS;
exports["default"] = _default;